import "./Social.css";

interface SocialProps {
  onBack?: () => void
  playHoverSound?: () => void
}

const GithubIcon = () => (
  <svg role="img" width={13} height={13} viewBox="0 0 24 24" fill="currentColor"><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" /></svg>
)

const LinkedinIcon = () => (
  <svg role="img" width={13} height={13} viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
)

const PFIcon = () => (
  <img src="/pf.svg" alt="Passion Fruit Software" width={13} height={13} className="social-pf-icon" />
)

const LINKS = [
  {
    href: 'https://github.com/Jackthomsonn',
    label: 'GITHUB',
    sublabel: 'jackthomsonn',
    Icon: GithubIcon,
    code: '01',
  },
  {
    href: 'https://www.linkedin.com/in/jackthomsonn',
    label: 'LINKEDIN',
    sublabel: 'jackthomsonn',
    Icon: LinkedinIcon,
    code: '02',
  },
  {
    href: 'https://passionfruitsoftware.com',
    label: 'PASSIONFRUIT SOFTWARE',
    sublabel: 'passionfruitsoftware.com',
    Icon: PFIcon,
    code: '03',
  },
]

export const Social = ({ onBack, playHoverSound }: SocialProps) => {
  return (
    <div className="social-panel">
      <button className="social-back" onClick={onBack} onMouseEnter={playHoverSound}>
        <span className="social-back__arrow">◀</span>
        <span>BACK</span>
      </button>

      <div className="social-header">
        <span className="social-tag">{'// NETWORK_LINKS.exe'}</span>
        <div className="social-header__line" />
      </div>

      <div className="social-links">
        {LINKS.map((link, i) => (
          <a
            key={link.href}
            href={link.href}
            target="_blank"
            rel="noreferrer"
            className="social-link"
            style={{ '--i': i } as React.CSSProperties}
            onMouseEnter={playHoverSound}
          >
            <span className="social-link__code">[{link.code}]</span>
            <span className="social-link__icon"><link.Icon /></span>
            <div className="social-link__text">
              <span className="social-link__label">{link.label}</span>
              <span className="social-link__sub">{link.sublabel}</span>
            </div>
            <span className="social-link__ext">
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <line x1="1.5" y1="9.5" x2="9.5" y2="1.5" />
                <polyline points="3.5,1.5 9.5,1.5 9.5,7.5" />
              </svg>
            </span>
          </a>
        ))}
      </div>
    </div>
  )
}
